import React, { createContext, useContext, useReducer } from "react";

/**
 * 인증 초기 상태
 * localStorage 기반으로 통일 (sessionStorage 사용하지 않음)
 * authService와 동일한 저장소를 참조하여 일관성 유지
 */
// 새로고침 시 복원: authService가 저장한 전체 user JSON(raoom_manage_user_data)에서 읽는다.
// (기존엔 존재하지 않는 "user_data"/"authority" 키를 읽어 userName/authority가 소실됐다.)
const storedUser = (() => {
  try {
    return JSON.parse(localStorage.getItem("raoom_manage_user_data")) || null;
  } catch {
    return null;
  }
})();

const initialState = {
  user: {
    userId: localStorage.getItem("userId") || storedUser?.id || null,
    userName: storedUser?.userName ?? null,
    authority:
      storedUser?.authority ??
      parseInt(localStorage.getItem("raoom_manage_authority") || "0"),
  },
};

const reducer = (state, action) => {
  switch (action.type) {
    case "LOGIN":
      const { userId, userName, authority } = action.data;
      // localStorage에 저장 (authService에서 이미 저장하지만 하위 호환성 유지)
      if (userId) localStorage.setItem("userId", userId);

      return {
        ...state,
        user: {
          userId,
          userName,
          authority: authority || 0,
        },
      };

    case "LOGOUT":
      return {
        ...state,
        user: {
          userId: null,
          userName: null,
          authority: 0,
        },
      };

    default:
      return state;
  }
};

const UserStateContext = createContext(null);
const UserDispatchContext = createContext(null);

export const UserProvider = ({ children }) => {
  const [state, dispatch] = useReducer(reducer, initialState);

  return (
    <UserStateContext.Provider value={state}>
      <UserDispatchContext.Provider value={dispatch}>
        {children}
      </UserDispatchContext.Provider>
    </UserStateContext.Provider>
  );
};

export const useUserState = () => {
  const state = useContext(UserStateContext);
  if (!state) throw new Error("Cannot find UserProvider");
  return state;
};

export const useUserDispatch = () => {
  const dispatch = useContext(UserDispatchContext);
  if (!dispatch) throw new Error("Cannot find UserProvider");
  return dispatch;
};
